import Vue from 'vue'
import Router from 'vue-router'
import generate  from '../views/generate/Index.vue'
import bi  from '../views/bi/Index.vue'
import pageDesigner  from '../components/PageDesigner/index.vue'
import NormalTable from '../components/template/NormalTable'
import callScreen from '../views/web/callScreen/index.vue'
import api from '../views/api/Index'
import BiConfigSet from '../views/bi/base/dataSource/config/index'
import biModelDesigner from '../views/bi/base/dataGroup/model/model-designer.vue'
import WebArchiveFill from '../views/web/fill/archive/index.vue'

import ArchiveHomeInfo from '../views/ph/archive/home/home-info.vue'



Vue.use(Router)


import Index from '@/views/Index'

export const constantRoutes = [
    {
      path: "/login",
      component: () => import('@/views/Login'),
      hidden: true
    },
    {
      path: "/test1",
      component: () => import('@/views/Test'),
      hidden: true
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
    // {
    //   path: "/web-archive-fill",
    //   name: "WebArchiveFill",
    //   component: WebArchiveFill,
    //   meta: {
    //     title: '建档登记'
    //   },
    //   hidden: true
    // },
    {
      path: '/',
      redirect: '/home',
      component: Index,
      children: [
        {
          path: "/home",
          name: '公卫管理系统',
          component: () => import('@/views/Home'),
          meta:{
            title: '首页'
          }
        },
        {
          path: '/bi-config-set-:id', // 定义了一个名为 id 的动态路径参数
          name: "BI数据源配置",
          component: BiConfigSet,
          props: true, // 将 URL 参数作为组件的 props 传递
          meta:{
            title: 'BI数据源配置'
          }
        },
        {
          path: '/nt-:id', // 定义了一个名为 id 的动态路径参数
          name: "nt",
          component: NormalTable,
          props: true, // 将 URL 参数作为组件的 props 传递
          meta:{
            title: '测试1页面'
          }
        }
      ]
    },
    {
      path: "/generate",
      redirect: '/generate-page',
      component: generate,
      children: [
        {
          path: "/generate-page",
          name: '代码生成',
          component: () => import('@/views/generate/page/index'),
          meta:{
            title: '代码生成'
          }
        },
        {
          path: "/generate-object",
          name: '对象',
          component: () => import('@/views/generate/object/object-list'),
          meta:{
            title: '对象'
          }
        }
      ]
    },
    {
      path: "/bi",
      redirect: '/bi-dataGroup',
      component: bi,
      children: [
        {
          path: "/bi-dataGroup",
          name: '数据集',
          component: () => import('@/views/bi/base/dataGroup/dataGroup-list'),
          meta:{
            title: '数据集'
          }
        },
        {
          path: "/bi-report",
          name: '数据集',
          component: () => import('@/views/bi/business/report/report-list'),
          meta:{
            title: '数据集'
          }
        }
      ]
    },
    {
      path: "/biModelDesigner",
      name: "biModelDesigner",
      component: biModelDesigner,
      meta:{
        title: '模型设计'
      }
    },
    {
      path: "/pageDesigner",
      name: "pageDesigner",
      component: pageDesigner,
      meta:{
        title: '页面编辑器'
      }
    },
    {
      path: "/testPage",
      name: "testPage",
      component: {
        template: '<div>1212</div>'
      },
      meta:{
        title: '测试页面'
      }
    },
    {
      path: "/callScreen",
      name: "callScreen",
      component: callScreen,
      meta:{
        title: '叫号列表'
      }
    },
    {
      path: "/api",
      redirect: '/api-form',
      component: api,
      children: [
        {
          path: "/api-form",
          name: '表格',
          component: () => import('@/views/api/form/index'),
          meta:{
            title: '表格'
          }
        },
        {
          path: "/api-table",
          name: '表格',
          component: () => import('@/views/api/table/index'),
          meta:{
            title: '表格'
          }
        }
      ]
    },
    {
      path: "/app-download",
      name: "AppDownload",
      component: () => import('@/views/weChat/app-download'),
      meta: {
        title: 'APP下载'
      },
      hidden: true
    },
    {
      path: "/web-archive-fill",
      name: "webArchiveFill",
      component: WebArchiveFill,
      meta: {
        title: '建档登记'
      },
      hidden: true
    },
    {
      path: "/archive-home-info",
      name: "archiveHomeInfo",
      component: ArchiveHomeInfo,
      meta: {
        title: '档案首页'
      },
      hidden: true
    }

]


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js